import { styled } from '@mui/material'
import Grid from '@mui/material/Grid2'

export const TitleWrapper = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0',
    },
}))
